import React from 'react';

import FormFieldLabel from './FormFieldLabel';
import { IFormFieldProps } from './models';
import { useFormField } from './useFormField';

const activeBgColor = 'var(--surface-surface-hover)';
const defaultBgColor = 'var(--surface-surface-active)';

interface IProps extends IFormFieldProps {
  min: number;
  max: number;
  step?: number;
  formatValue?: (value: number) => string | number;
}

function FormSliderField({
  name,
  label,
  optional,
  min,
  max,
  size = 50,
  step = 1,
  formatValue = (value) => value,
}: IProps) {
  const { id, fieldProps, inputProps, meta } = useFormField(name, size);

  const getSliderBackground = (value: number): string => {
    const percent = ((value - min) / (max - min)) * 100;
    return (
      `linear-gradient(to right, ${activeBgColor} 0%, ${activeBgColor} ${percent}%,` +
      ` ${defaultBgColor} ${percent}%, ${defaultBgColor} 100%)`
    );
  };

  return (
    <div {...fieldProps}>
      {label && (
        <FormFieldLabel htmlFor={id} optional={optional}>
          {label}
        </FormFieldLabel>
      )}
      <div className="modFormField__slider-container">
        <div className="modFormFieldSlider">
          <p className="modFormFieldSlider__value">{formatValue(min)}</p>
          <input
            type="range"
            step={step}
            min={min}
            max={max}
            {...inputProps}
            className="modFormFieldSlider__slider"
            style={{ background: getSliderBackground(meta.value) }}
          />
          <p className="modFormFieldSlider__value">{formatValue(max)}</p>
        </div>
        <p className="modFormField__slider-container__current">{formatValue(meta.value)}</p>
      </div>
    </div>
  );
}

export default FormSliderField;
